const ITEMS = [
  "24/7 Heavy Duty Towing",
  "Mobile Truck & Trailer Repair",
  "Roadside Diesel Repair",
  "We Buy Junk Cars",
  "Building Demolition",
  "Car Lockouts",
  "Rated 4.8/5",
  "Rittman & Cleveland, OH",
  "(330) 201-4612",
];

export default function Marquee() {
  const row = (hidden) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="px-8 font-display text-2xl font-bold uppercase tracking-wide text-slate-200 sm:text-3xl">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-ember" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="dispatch-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-surface py-5"
    >
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
